import HealthServicesCard from '@website/components/HealthService/HealthServicesCard';
import PartnerIcon from '../svg/PartnerIcon';
import HeartIcon from '../svg/HeartIcon';

import healthServicesImage1 from '@website/assets/img/health-services-1.png';
import healthServicesImage2 from '@website/assets/img/health-services-2.png';
import healthServicesImage3 from '@website/assets/img/health-services-3.png';
import healthServicesImage4 from '@website/assets/img/health-services-4.png';
import healthServicesImage5 from '@website/assets/img/health-services-5.png';
import healthServicesImage6 from '@website/assets/img/health-services-6.png';
import healthServicesImage7 from '@website/assets/img/health-services-7.png';
import healthServicesImage8 from '@website/assets/img/health-services-8.png';
import healthServicesImage9 from '@website/assets/img/health-services-9.png';
import healthServicesImage10 from '@website/assets/img/health-services-10.png';
import healthServicesImage11 from '@website/assets/img/health-services-11.png';
import healthServicesImage12 from '@website/assets/img/health-services-12.png';
import {useTranslations} from 'next-intl';
import Link from 'next/link';

const clientImages = [
  {
    src: healthServicesImage1,
    alt: 'Therapy session',
    width: 200,
    height: 200,
    className: 'object-cover',
  },
  {
    src: healthServicesImage4,
    alt: 'Person holding sign',
    width: 200,
    height: 200,
    className: 'object-cover mt-8',
  },
  {
    src: healthServicesImage2,
    alt: 'Group of friends selfie',
    width: 300,
    height: 400,
    className: 'object-cover',
  },
  {src: healthServicesImage3, alt: 'Online meeting', width: 200, height: 200},
  {
    src: healthServicesImage5,
    alt: 'Artistic portrait',
    width: 300,
    height: 200,
    className: 'object-cover',
  },
  {
    src: healthServicesImage6,
    alt: 'Person reading book',
    width: 300,
    height: 200,
    className: 'object-cover',
  },
];

const partnerImages = [
  {
    src: healthServicesImage7,
    alt: 'image-7',
    width: 300,
    height: 200,
  },
  {
    src: healthServicesImage10,
    alt: 'image-10',
    width: 300,
    height: 200,
    className: 'object-cover mt-8',
  },
  {
    src: healthServicesImage8,
    alt: 'Image-8',
    width: 200,
    height: 200,
  },
  {
    src: healthServicesImage9,
    alt: 'Image-9',
    width: 300,
    height: 200,
  },
  {
    src: healthServicesImage11,
    alt: 'Image-11',
    width: 300,
    height: 200,
  },
  {
    src: healthServicesImage12,
    alt: 'Image-12',
    width: 200,
    height: 200,
  },
];

export const HealthServicesNavigation = () => {
  const t = useTranslations('HealthServices');
  return (
    <section className="p-10 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-6 md:mb-8 max-w-4xl">
          <h1 className="text-4xl md:text-4xl font-montserrat font-bold mb-2">
            {t('title')}
          </h1>
          <h2 className="text-2xl md:text-3xl mb-2">{t('subtitle')}</h2>
          <div className="flex flex-row items-center gap-2">
            <p className="text-lg leading-relaxed">{t('description')}</p>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-4">
          <Link href="/conditions" className="cursor-pointer">
            <HealthServicesCard
              icon={<HeartIcon className="w-8 h-8" />}
              label={t('clientLabel')}
              title={t('clientTitle')}
              description={t('clientDescription')}
              images={clientImages}
              buttonText={t('clientButtonText')}
              buttonHref="/conditions"
              cardClasses="lg:bg-gray-100 hover:bg-pink-100 bg-pink-100"
            />
          </Link>
          <Link href="/benefits" className="cursor-pointer">
            <HealthServicesCard
              icon={<PartnerIcon className="w-8 h-8" />}
              label={t('partnerLabel')}
              title={t('partnerTitle')}
              description={t('partnerDescription')}
              images={partnerImages}
              buttonText={t('partnerButtonText')}
              buttonHref="/benefits"
              cardClasses="lg:bg-gray-100 hover:bg-purple-100 bg-purple-100"
            />
          </Link>
        </div>
      </div>
    </section>
  );
};
